import type { RemoteConfig } from '@funtech-int/yango-shared';
import { LegacyEpisodePlayerBaseInfoContent } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { ProfileManager } from '@/shared/lib/profileManager';
import { Source } from '@/scenarios/legacy-player/types/config';

import type { PlayerFeatureFlags } from '../../../lib/featureFlags';
import { TelemetryContentPlace, TelemetryContentType } from '../../Player';
import { getOnlineStreamsConfig } from '../../feature-player/utils/config/get-online-streams-config';

import { getEpisodeOnlineStreams } from './get-episode-online-streams';
import { getEpisodePreferredTracks } from './get-episode-preferred-tracks';
import { getEpisodeStartPosition } from './get-episode-start-position';
import { getEpisodeContentId } from './get-episode-content-id';

interface Dependencies {
    profileManager: ProfileManager;
    featureFlags: PlayerFeatureFlags;
    remoteConfig: RemoteConfig;
}

export const getEpisodePlayerConfig: (
    episode: LegacyEpisodePlayerBaseInfoContent,
    deps: Dependencies
) => Source[] = (episode, deps) =>
    getOnlineStreamsConfig(
        {
            contentId: getEpisodeContentId(episode),
            preferredTracks: getEpisodePreferredTracks(episode),
            onlineStreams: getEpisodeOnlineStreams(episode),
            startPosition: getEpisodeStartPosition(episode),
            telemetry: {
                from_block: TelemetryContentPlace.Series,
                stream_block: TelemetryContentType.Episode,
            },
        },
        deps
    );
